var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorrowingCapacity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.334 48V33l-9 15h9z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.334 27v22h-10M73.334 31v31h-19M17.334 23L36.593 9l20.74 14M55.334 17.5l2.759-2.5 18.24 12",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 48h.774a37 37 0 0114.759 3.07l1.782.776h7.684a3 3 0 013 3V55a3 3 0 01-2.998 3h-9.002",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 63h1.102a16 16 0 015.61 1.016l9.522 3.565a9 9 0 007.367-.475l18.889-10a2.47 2.47 0 00.845-3.63v0a2.47 2.47 0 00-2.793-.892L39.834 57M6.333 44h6v23h-6z",
    stroke: "#10C98E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.834,
    cy: 33.5,
    r: 10.5,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.944 36.536a1 1 0 00-.651 1.89l.651-1.89zm1.6 1.273l.005-1h-.005v1zm2.275-1.6l.986.17-.986-.17zm-.68-1.848l.638-.77-.002-.002-.636.772zm-1.883-.594l-.188.982.008.001.18-.983zm-1.472-.727l-.771.637.004.005.767-.642zm-.432-1.595l-.986-.17v.006l.986.164zm2.276-1.6l-.004 1 .004-1zm1.577 1.265a1 1 0 00.696-1.875l-.696 1.875zm-3.587 6.371l-.325.946h.001l.002.001c.001 0 .003 0 .005.002l.013.004a5.587 5.587 0 00.186.058c.12.035.29.082.493.128.4.091.96.189 1.55.19l.001-2c-.385 0-.787-.067-1.106-.14a6.385 6.385 0 01-.471-.127l-.022-.007h-.003.001l-.325.945zm1.92 1.328a3.72 3.72 0 001.966-.55c.612-.384 1.15-1.009 1.3-1.88l-1.97-.34c-.034.197-.154.376-.394.526a1.721 1.721 0 01-.89.244l-.012 2zm3.267-2.43a2.979 2.979 0 00-1.028-2.788l-1.277 1.54a.98.98 0 01.334.907l1.97.34zm-1.03-2.79c-.424-.349-.895-.516-1.294-.614-.358-.088-.813-.15-1.044-.192l-.361 1.967c.41.075.635.095.927.167.251.062.4.133.5.216l1.272-1.544zm-2.33-.804c-.502-.097-.756-.221-.894-.386l-1.534 1.283c.605.724 1.457.953 2.051 1.067l.377-1.965zm-.889-.38a1.023 1.023 0 01-.218-.796l-1.973-.328c-.14.85.105 1.737.648 2.395l1.543-1.272zm-.219-.79c.051-.295.17-.449.316-.55.169-.116.472-.222.971-.22l.007-2c-.762-.003-1.505.156-2.112.573-.631.434-1.019 1.083-1.153 1.857l1.971.34zm1.288-.77a5.153 5.153 0 011.565.26l.017.005h-.001l.347-.938.347-.937h-.001l-.002-.002-.005-.001-.013-.005a3.66 3.66 0 00-.184-.06 7.145 7.145 0 00-2.065-.322l-.005 2z",
    fill: "#7E776E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.788 38.469v1.777M36.805 27.312l-.003 1.73",
    stroke: "#7E776E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M63.334 29h5v5h-5zM63.334 39h5v5h-5zM63.334 49h5v13h-5z"
  })));
}
export default SvgBorrowingCapacity;